import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

// Import statiques
import Accueil from '@/views/Accueil.vue'
import Login from '@/views/Login.vue'

// Import dynamiques
const CapaciteFinanciere = () => import('@/views/CapaciteFinanciere.vue')
const CapaciteAchat = () => import('@/views/CapaciteAchat.vue')
const CalculerPrix = () => import('@/views/CalculerPrix.vue')
const Commande = () => import('@/views/Commande.vue')
const CommandeDetail = () => import('@/views/CommandeDetail.vue')
const ListeCommandeDemandeur = () =>
  import('@/views/ListeCommandeDemandeur.vue')
const MdpOublie = () => import('@/views/MdpOublie.vue')
const ProfilEdit = () => import('@/views/ProfilEdit.vue')
const ProduitDisponible = () => import('@/views/ProduitDisponible.vue')
const Rapports = () => import('@/views/Rapports.vue')
const Recherche = () => import('@/views/Recherche.vue')
const ReinitialiserMdp = () => import('@/views/ReinitialiserMdp.vue')
const TokenExpire = () => import('@/views/TokenExpire.vue')
const PageNotFoundComponent = () => import('@/views/PageNotFoundComponent.vue')

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    { path: '/accueil', name: 'accueil', component: Accueil },
    {
      path: '/calculerPrix',
      name: 'calculerPrix',
      component: CalculerPrix
    },
    {
      path: '/capaciteFinanciere',
      name: 'capaciteFinanciere',
      component: CapaciteFinanciere
    },
    {
      path: '/capaciteAchat',
      name: 'capaciteAchat',
      component: CapaciteAchat
    },
    {
      path: '/commande/:idCommande/:copie',
      name: 'commande',
      component: Commande
    },
    {
      path: '/commandeDetail/:idCommande',
      name: 'commandeDetail',
      component: CommandeDetail
    },
    {
      path: '/listeCommandeDemandeur/:statutCommandeIP',
      name: 'listeCommandeDemandeur',
      component: ListeCommandeDemandeur
    },
    {
      path: '/mdp',
      name: 'mdpOublie',
      component: MdpOublie,
      meta: { anonymous: true }
    },
    {
      path: '/mdp/reinitialiser/:token',
      name: 'mdpReinitialiser',
      component: ReinitialiserMdp,
      meta: { anonymous: true }
    },
    {
      path: '/profilEdit',
      name: 'profilEdit',
      component: ProfilEdit
    },
    {
      path: '/produitDisponible',
      name: 'produitDisponible',
      component: ProduitDisponible
    },
    { path: '/rapports', name: 'rapports', component: Rapports },
    { path: '/recherche', name: 'recherche', component: Recherche },
    // anonymous
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: { anonymous: true }
    },
    {
      path: '/tokenExpire',
      name: 'tokenExpire',
      component: TokenExpire,
      meta: { anonymous: true }
    },
    // pages techniques
    { path: '/index.html', name: 'index', component: Accueil },
    { path: '/', redirect: { name: 'accueil' } },
    { path: '*', component: PageNotFoundComponent, meta: { anonymous: true } }
  ]
})

router.beforeEach((to, from, next) => {
  if (store.getters.estAuthentifie && to.name === 'login') {
    console.log(
      `Usage authentifie qui tente d'acceder a la page de login, on redirige vers accueil`
    )
    next({ name: 'accueil' })
    return
  }

  // Anonymous page: continue
  if (to.meta.anonymous) {
    console.info(`Acces anonyme, on continue vers ${to.fullPath}`)
    next()
    return
  }

  // Check is user logged in. If not redirect to login
  if (store.getters.estAuthentifie) {
    console.info(`Usager connecte, on continue vers ${to.fullPath}`)
    next()
    return
  }

  // Redirect to login page
  console.info('User pas connecte, redirection vers /login')
  next('login')
})

export default router
